import { apiRequest } from "../services/apiRequest"
import { PLAN_TYPE_TO_API } from "../utils/plansPricingPayload"

const STATUS_TO_API = {
  Active: "active",
  Inactive: "inactive",
  Draft: "draft",
}

export const PlansApi = {
  getPlansList: async ({
    search = "",
    status = "all",
    type = "all",
    /** standard | organization — maps to query `plan_type` (not Subscription/One-Time `type`) */
    planCategory = "all",
    page = 1,
    pageSize = 10,
  } = {}) => {
    const queryParams = new URLSearchParams()

    if (search?.trim()) queryParams.set("search", search.trim())
    if (status && status !== "all") {
      const apiStatus = STATUS_TO_API[status] || status.toLowerCase()
      queryParams.set("status", apiStatus)
    }
    if (type && type !== "all") {
      const apiType =
        PLAN_TYPE_TO_API[type] || type.toLowerCase().replace(/-/g, "_")
      queryParams.set("type", apiType)
    }
    if (planCategory && planCategory !== "all") {
      queryParams.set(
        "plan_type",
        String(planCategory).trim().toLowerCase().replace(/\s+/g, "_")
      )
    }
    if (page > 0) queryParams.set("page", String(page))
    if (pageSize > 0) queryParams.set("page_size", String(pageSize))

    const qs = queryParams.toString()
    const url = `/account/admin/plans/${qs ? `?${qs}` : ""}`

    return await apiRequest("get", url, undefined, { skipCache: true })
  },

  createPlan: async (payload) => {
    return await apiRequest("post", "/account/admin/plans/", payload)
  },

  getPlanById: async (planId) => {
    return await apiRequest(
      "get",
      `/account/admin/plans/${planId}/`,
      undefined,
      { skipCache: true }
    )
  },

  getPlanFeatures: async () => {
    return await apiRequest(
      "get",
      "/account/admin/plans/features/",
      undefined,
      { skipCache: true }
    )
  },

  updatePlan: async (planId, payload) => {
    return await apiRequest("put", `/account/admin/plans/${planId}/`, payload)
  },

  patchPlan: async (planId, payload) => {
    return await apiRequest("patch", `/account/admin/plans/${planId}/`, payload)
  },

  duplicatePlan: async (planId, payload = { duplicate: true }) => {
    return await apiRequest("post", `/account/admin/plans/${planId}/`, payload)
  },

  deletePlan: async (planId) => {
    return await apiRequest("delete", `/account/admin/plans/${planId}/`)
  },
}
